export const environment = {
  production: false,
  apiURL: 'https://devservices.airefined.com',
  logo: `./assets/logo/silverline-logo-web.png`,
  appTitle: 'OCKW',
  appInsights: {
    instrumentationKey: '3a8f923b-af77-40c3-af6b-71314465ce52',
    disableExceptionTracking: true
  },
  azureBlobStorage: 'https://azstdatadevuksouthoc.blob.core.windows.net',
  fileSizeLimit: '1GB',
  emailAddress: "akash.agarwal@airefined.com"
};
